const DEFAULT_SUBMISSION_TYPE = '2';

export class AusSubmitApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAusSubmitOperations({ companyId, loanId }) {
    return this.#http.get(`ausSubmit/operations/${companyId}/${loanId}`);
  }

  async startAusSubmit({
    companyId,
    loanId,
    submissionType = DEFAULT_SUBMISSION_TYPE,
    duCasefileId,
    lpAusKey,
    pendingChangesLoadScope,
  }) {
    return this.#http.post(`StartAusSubmit/${companyId}/${loanId}/${submissionType}`, {
      pendingChangesLoadScope,
      duCasefileId,
      lpAusKey,
    });
  }

  async getMismoImportCasefile({ companyId, loanId }) {
    return this.#http.get(`aus/mismo-import/casefile/${companyId}/${loanId}`);
  }
}
